import { format } from "date-fns";
import { INPUT_DATE_STRING_FORMAT_DATE, INPUT_DATE_STRING_FORMAT_MONTH, } from "./parse-date.js";
export const formatDateForInput = (date, locale, type, inputFormat) => {
    const INPUT_DATE_STRING_FORMAT = inputFormat !== null && inputFormat !== void 0 ? inputFormat : (type === "date"
        ? INPUT_DATE_STRING_FORMAT_DATE
        : INPUT_DATE_STRING_FORMAT_MONTH);
    return format(date, INPUT_DATE_STRING_FORMAT, { locale });
};
//# sourceMappingURL=format-date.js.map